module.exports = global["$"] = require("-!/home/homegroupss4/rewards.homegroup.com.au/node_modules/expose-loader/index.js?jQuery!./jquery.js");